export const getPhoneMask = (countryCode) => {
    switch (countryCode) {
        case 'AD': // Andorra
            return '+376 999 999';
        case 'AE': // United Arab Emirates
            return '+971 999 999 9999';
        case 'AF': // Afghanistan
            return '+93 99 999 9999';
        case 'AG': // Antigua and Barbuda
            return '+1 (268) 999-9999';
        case 'AI': // Anguilla
            return '+1 (264) 999-9999';
        case 'AL': // Albania
            return '+355 999 999 999';
        case 'AM': // Armenia
            return '+374 999 99999';
        case 'AO': // Angola
            return '+244 999 999 999';
        case 'AR': // Argentina
            return '+54 999 999 9999';
        case 'AS': // American Samoa
            return '+1 (684) 999-9999';
        case 'AT': // Austria
            return '+43 999 999999999';
        case 'AU': // Australia
            return '+61 9999 9999';
        case 'AW': // Aruba
            return '+297 999 9999';
        case 'AX': // Åland Islands
            return '+358 18 999999999';
        case 'AZ': // Azerbaijan
            return '+994 999 999 999';
        case 'BA': // Bosnia and Herzegovina
            return '+387 999 999 999';
        case 'BB': // Barbados
            return '+1 (246) 999-9999';
        case 'BD': // Bangladesh
            return '+880 99999 99999';
        case 'BE': // Belgium
            return '+32 999 99 99 99';
        case 'BF': // Burkina Faso
            return '+226 99 99 99 99';
        case 'BG': // Bulgaria
            return '+359 999 999-999';
        case 'BH': // Bahrain
            return '+973 9999 9999';
        case 'BI': // Burundi
            return '+257 9999 9999';
        case 'BJ': // Benin
            return '+229 99 99 99 99';
        case 'BL': // Saint Barthélemy
            return '+590 9999 9999';
        case 'BM': // Bermuda
            return '+1 (441) 999-9999';
        case 'BN': // Brunei Darussalam
            return '+673 999 9999';
        case 'BO': // Bolivia, Plurinational State of
            return '+591 9999 9999';
        case 'BQ': // Bonaire, Sint Eustatius and Saba
            return '+599 9999 9999';
        case 'BR': // Brazil
            return '+55 99 9999-9999';
        case 'BS': // Bahamas
            return '+1 (242) 999-9999';
        case 'BT': // Bhutan
            return '+975 9999 9999';
        case 'BV': // Bouvet Island
            return '+47 999 99 999';
        case 'BW': // Botswana
            return '+267 9999 9999';
        case 'BY': // Belarus
            return '+375 999 999 999';
        case 'BZ': // Belize
            return '+501 999 9999';
        case 'CA': // Canada
            return '+1 (999) 999-9999';
        case 'CC': // Cocos (Keeling) Islands
            return '+61 9999 9999';
        case 'CD': // Congo, the Democratic Republic of the
            return '+243 99 999 9999';
        case 'CF': // Central African Republic
            return '+236 99 99 99 99';
        case 'CG': // Congo
            return '+242 99 999 9999';
        case 'CH': // Switzerland
            return '+41 99 999 99 99';
        case 'CI': // Côte d'Ivoire
            return '+225 99 99 99 99';
        case 'CK': // Cook Islands
            return '+682 9999 9999';
        case 'CL': // Chile
            return '+56 99 9999 9999';
        case 'CM': // Cameroon
            return '+237 9999 9999';
        case 'CN': // China
            return '+86 9999 9999';
        case 'CO': // Colombia
            return '+57 999 999 9999';
        case 'CR': // Costa Rica
            return '+506 9999 9999';
        case 'CU': // Cuba
            return '+53 99 9999999';
        case 'CV': // Cape Verde
            return '+238 999 99 99';
        case 'CW': // Curaçao
            return '+599 9999 9999';
        case 'CX': // Christmas Island
            return '+61 9999 9999';
        case 'CY': // Cyprus
            return '+357 9999 9999';
        case 'CZ': // Czech Republic
            return '+420 999 999 999';
        case 'DE': // Germany
            return '+49 999 999999999';
        case 'DJ': // Djibouti
            return '+253 99 99 99 99';
        case 'DK': // Denmark
            return '+45 99 99 99 99';
        case 'DM': // Dominica
            return '+1 (767) 999-9999';
        case 'DO': // Dominican Republic
            return '+1 (809) 999-9999';
        case 'DZ': // Algeria
            return '+213 9999 999 999';
        case 'EC': // Ecuador
            return '+593 999 999 9999';
        case 'EE': // Estonia
            return '+372 9999 9999';
        case 'EG': // Egypt
            return '+20 9999 999 9999';
        case 'EH': // Western Sahara
            return '+212 9999 9999';
        case 'ER': // Eritrea
            return '+291 999 9999';
        case 'ES': // Spain
            return '+34 999 999 999';
        case 'ET': // Ethiopia
            return '+251 999 999 999';
        case 'FI': // Finland
            return '+358 999 9999999';
        case 'FJ': // Fiji
            return '+679 999 9999';
        case 'FK': // Falkland Islands (Malvinas)
            return '+500 9999 9999';
        case 'FM': // Micronesia, Federated States of
            return '+691 999 9999';
        case 'FO': // Faroe Islands
            return '+298 999 999';
        case 'FR': // France
            return '+33 (0) 6 12 34 56 78';
        case 'GA': // Gabon
            return '+241 99 99 99 99';
        case 'GB': // United Kingdom
            return '+44 9999 999999';
        case 'GD': // Grenada
            return '+1 (473) 999-9999';
        case 'GE': // Georgia
            return '+995 999 99 9999';
        case 'GF': // French Guiana
            return '+594 9999 99 99 99';
        case 'GG': // Guernsey
            return '+44 1481 999999';
        case 'GH': // Ghana
            return '+233 99 999 9999';
        case 'GI': // Gibraltar
            return '+350 999 99999';
        case 'GL': // Greenland
            return '+299 999 999';
        case 'GM': // Gambia
            return '+220 999 9999';
        case 'GN': // Guinea
            return '+224 9999 9999';
        case 'GP': // Guadeloupe
            return '+590 9999 9999';
        case 'GQ': // Equatorial Guinea
            return '+240 999 999 999';
        case 'GR': // Greece
            return '+30 999 999 9999';
        case 'GS': // South Georgia and the South Sandwich Islands
            return '+500 9999 9999';
        case 'GT': // Guatemala
            return '+502 9999 9999';
        case 'GU': // Guam
            return '+1 (671) 999-9999';
        case 'GW': // Guinea-Bissau
            return '+245 9999 9999';
        case 'GY': // Guyana
            return '+592 999 9999';
        case 'HK': // Hong Kong
            return '+852 9999 9999';
        case 'HM': // Heard Island and McDonald Islands
            return '+672 9999 9999';
        case 'HN': // Honduras
            return '+504 9999 9999';
        case 'HR': // Croatia
            return '+385 99 999 9999';
        case 'HT': // Haiti
            return '+509 99 99 9999';
        case 'HU': // Hungary
            return '+36 99 999 9999';
        case 'ID': // Indonesia
            return '+62 999 9999 9999';
        case 'IE': // Ireland
            return '+353 99 999 9999';
        case 'IL': // Israel
            return '+972 999-999-9999';
        case 'IM': // Isle of Man
            return '+44 1624 999999';
        case 'IN': // India
            return '+91 99999 99999';
        case 'IO': // British Indian Ocean Territory
            return '+246 9999 9999';
        case 'IQ': // Iraq
            return '+964 999 999 9999';
        case 'IR': // Iran, Islamic Republic of
            return '+98 9999 999 9999';
        case 'IS': // Iceland
            return '+354 999 9999';
        case 'IT': // Italy
            return '+39 999 999 9999';
        case 'JE': // Jersey
            return '+44 1534 999999';
        case 'JM': // Jamaica
            return '+1 (876) 999-9999';
        case 'JO': // Jordan
            return '+962 9999 9999';
        case 'JP': // Japan
            return '+81 999-9999-9999';
        case 'KE': // Kenya
            return '+254 9999 999999';
        case 'KG': // Kyrgyzstan
            return '+996 9999 999 999';
        case 'KH': // Cambodia
            return '+855 9999 9999';
        case 'KI': // Kiribati
            return '+686 9999 9999';
        case 'KM': // Comoros
            return '+269 999 9999';
        case 'KN': // Saint Kitts and Nevis
            return '+1 (869) 999-9999';
        case 'KP': // Korea, Democratic People's Republic of
            return '+850 999 999 9999';
        case 'KR': // Korea, Republic of
            return '+82 999 999 9999';
        case 'KW': // Kuwait
            return '+965 9999 9999';
        case 'KY': // Cayman Islands
            return '+1 (345) 999-9999';
        case 'KZ': // Kazakhstan
            return '+7 (999) 999-9999';
        case 'LA': // Lao People's Democratic Republic
            return '+856 20 99 999 999';
        case 'LB': // Lebanon
            return '+961 99 999 999';
        case 'LC': // Saint Lucia
            return '+1 (758) 999-9999';
        case 'LI': // Liechtenstein
            return '+423 999 9999';
        case 'LK': // Sri Lanka
            return '+94 999 999 9999';
        case 'LR': // Liberia
            return '+231 9999 9999';
        case 'LS': // Lesotho
            return '+266 9999 9999';
        case 'LT': // Lithuania
            return '+370 999 99999';
        case 'LU': // Luxembourg
            return '+352 999 999 999';
        case 'LV': // Latvia
            return '+371 9999 9999';
        case 'LY': // Libya
            return '+218 99 999 9999';
        case 'MA': // Morocco
            return '+212 99999 99999';
        case 'MC': // Monaco
            return '+377 9999 9999';
        case 'MD': // Moldova, Republic of
            return '+373 9999 9999';
        case 'ME': // Montenegro
            return '+382 99 999 999';
        case 'MF': // Saint Martin (French part)
            return '+590 9999 9999';
        case 'MG': // Madagascar
            return '+261 999 99 999 99';
        case 'MH': // Marshall Islands
            return '+692 999 9999';
        case 'MK': // Macedonia, the former Yugoslav Republic of
            return '+389 9999 9999';
        case 'ML': // Mali
            return '+223 99 99 9999';
        case 'MM': // Myanmar
            return '+95 99 999 9999';
        case 'MN': // Mongolia
            return '+976 9999 9999';
        case 'MO': // Macao
            return '+853 9999 9999';
        case 'MP': // Northern Mariana Islands
            return '+1 (670) 999-9999';
        case 'MQ': // Martinique
            return '+596 9999 99 99 99';
        case 'MR': // Mauritania
            return '+222 99 99 9999';
        case 'MS': // Montserrat
            return '+1 (664) 999-9999';
        case 'MT': // Malta
            return '+356 9999 9999';
        case 'MU': // Mauritius
            return '+230 9999 9999';
        case 'MV': // Maldives
            return '+960 999 9999';
        case 'MW': // Malawi
            return '+265 9999 9999';
        case 'MX': // Mexico
            return '+52 999 9999 9999';
        case 'MY': // Malaysia
            return '+60 9999 999 999';
        case 'MZ': // Mozambique
            return '+258 999 999 999';
        case 'NA': // Namibia
            return '+264 999 999 999';
        case 'NC': // New Caledonia
            return '+687 99.99.99';
        case 'NE': // Niger
            return '+227 99 99 9999';
        case 'NF': // Norfolk Island
            return '+672 3 99999';
        case 'NG': // Nigeria
            return '+234 999 999 9999';
        case 'NI': // Nicaragua
            return '+505 9999 9999';
        case 'NL': // Netherlands
            return '+31 (0) 6 99999999';
        case 'NO': // Norway
            return '+47 999 99 999';
        case 'NP': // Nepal
            return '+977 9999999999';
        case 'NR': // Nauru
            return '+674 999 9999';
        case 'NU': // Niue
            return '+683 9999';
        case 'NZ': // New Zealand
            return '+64 999 999 9999';
        case 'OM': // Oman
            return '+968 9999 9999';
        case 'PA': // Panama
            return '+507 9999 9999';
        case 'PE': // Peru
            return '+51 999 999 999';
        case 'PF': // French Polynesia
            return '+689 99.99.99';
        case 'PG': // Papua New Guinea
            return '+675 9999 9999';
        case 'PH': // Philippines
            return '+63 999 999 9999';
        case 'PK': // Pakistan
            return '+92 9999 9999999';
        case 'PL': // Poland
            return '+48 999 999 999';
        case 'PM': // Saint Pierre and Miquelon
            return '+508 999 99 99';
        case 'PN': // Pitcairn
            return '+872 999 99 99';
        case 'PR': // Puerto Rico
            return '+1 (787) 999-9999';
        case 'PS': // Palestine, State of
            return '+970 9999 9999';
        case 'PT': // Portugal
            return '+351 999 999 999';
        case 'PW': // Palau
            return '+680 999 9999';
        case 'PY': // Paraguay
            return '+595 999 999999';
        case 'QA': // Qatar
            return '+974 9999 9999';
        case 'RE': // Réunion
            return '+262 9999 99 99 99';
        case 'RO': // Romania
            return '+40 999 999 999';
        case 'RS': // Serbia
            return '+381 99 9999999';
        case 'RU': // Russian Federation
            return '+7 999 999-99-99';
        case 'RW': // Rwanda
            return '+250 999 999 999';
        case 'SA': // Saudi Arabia
            return '+966 999 999 9999';
        case 'SB': // Solomon Islands
            return '+677 99999';
        case 'SC': // Seychelles
            return '+248 999 99 99';
        case 'SD': // Sudan
            return '+249 999 999 999';
        case 'SE': // Sweden
            return '+46 99 999 9999';
        case 'SG': // Singapore
            return '+65 9999 9999';
        case 'SH': // Saint Helena, Ascension and Tristan da Cunha
            return '+290 9999';
        case 'SI': // Slovenia
            return '+386 99 999 999';
        case 'SJ': // Svalbard and Jan Mayen
            return '+47 79 99 99 99';
        case 'SK': // Slovakia
            return '+421 999 999 999';
        case 'SL': // Sierra Leone
            return '+232 99 999999';
        case 'SM': // San Marino
            return '+378 999 999999';
        case 'SN': // Senegal
            return '+221 9999 9999';
        case 'SO': // Somalia
            return '+252 9999 999 999';
        case 'SR': // Suriname
            return '+597 999 9999';
        case 'SS': // South Sudan
            return '+211 999 999 999';
        case 'ST': // Sao Tome and Principe
            return '+239 999 9999';
        case 'SV': // El Salvador
            return '+503 9999 9999';
        case 'SX': // Sint Maarten (Dutch part)
            return '+1 (721) 999-9999';
        case 'SY': // Syrian Arab Republic
            return '+963 9999 999 999';
        case 'SZ': // Swaziland
            return '+268 9999 9999';
        case 'TC': // Turks and Caicos Islands
            return '+1 (649) 999-9999';
        case 'TD': // Chad
            return '+235 99 99 99 99';
        case 'TF': // French Southern Territories
            return '+262 9999 99 99 99';
        case 'TG': // Togo
            return '+228 99 999 999';
        case 'TH': // Thailand
            return '+66 99 999 9999';
        case 'TJ': // Tajikistan
            return '+992 999 999 999';
        case 'TK': // Tokelau
            return '+690 9999';
        case 'TL': // Timor-Leste
            return '+670 9999 9999';
        case 'TM': // Turkmenistan
            return '+993 99 999999';
        case 'TN': // Tunisia
            return '+216 99 999 999';
        case 'TO': // Tonga
            return '+676 999 9999';
        case 'TR': // Turkey
            return '+90 9999 999 9999';
        case 'TT': // Trinidad and Tobago
            return '+1 (868) 999-9999';
        case 'TV': // Tuvalu
            return '+688 9999';
        case 'TW': // Taiwan, Province of China
            return '+886 9999 999 999';
        case 'TZ': // Tanzania, United Republic of
            return '+255 9999 999 999';
        case 'UA': // Ukraine
            return '+38 (999) 999-99-99';
        case 'UG': // Uganda
            return '+256 9999 999999';
        case 'UM': // United States Minor Outlying Islands
            return '+1 999 999 9999';
        case 'US': // United States
            return '+1 (999) 999-9999';
        case 'UY': // Uruguay
            return '+598 9999 9999';
        case 'UZ': // Uzbekistan
            return '+998 99 999 9999';
        case 'VA': // Holy See (Vatican City State)
            return '+379 999 999 999';
        case 'VC': // Saint Vincent and the Grenadines
            return '+1 (784) 999-9999';
        case 'VE': // Venezuela, Bolivarian Republic of
            return '+58 9999 9999999';
        case 'VG': // Virgin Islands, British
            return '+1 (284) 999-9999';
        case 'VI': // Virgin Islands, U.S.
            return '+1 (340) 999-9999';
        case 'VN': // Viet Nam
            return '+84 999 999 999';
        case 'VU': // Vanuatu
            return '+678 999 9999';
        case 'WF': // Wallis and Futuna
            return '+681 9999 99 99';
        case 'WS': // Samoa
            return '+685 99999';
        case 'YE': // Yemen
            return '+967 9999 999 999';
        case 'YT': // Mayotte
            return '+262 9999 99 99 99';
        case 'ZA': // South Africa
            return '+27 999 999 9999';
        case 'ZM': // Zambia
            return '+260 999 999 999';
        case 'ZW': // Zimbabwe
            return '+263 999 999 999';
        default:
            return '+38 (999) 999-99-99'; // Default mask for unrecognized country code
    }
};

export default getPhoneMask;
